import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M11.5862 15.9288L23.6863 3.82872C24.1046 3.41034 24.1046 2.73206 23.6863 2.31369C23.2678 1.89544 22.5896 1.89544 22.1712 2.31369L9.31369 15.1712C8.89544 15.5896 8.89544 16.2679 9.31369 16.6863L22.1712 29.5438C22.5969 29.9549 23.2752 29.9431 23.6863 29.5175C24.0872 29.1022 24.0872 28.444 23.6863 28.0288L11.5862 15.9288Z' })
));